'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

var _PropertyHelper = require('../common/PropertyHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	color: _propTypes2.default.string,
	innerStyle: _propTypes2.default.object,
	max: _propTypes2.default.number,
	min: _propTypes2.default.number,
	mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
	size: _propTypes2.default.number,
	style: _propTypes2.default.object,
	value: _propTypes2.default.number,
	thickness: _propTypes2.default.number
};

var allowedProperties = Object.keys(propTypes);

var WMCircularProgress = function WMCircularProgress(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_CircularProgress2.default, (0, _PropertyHelper.filter)(props, allowedProperties))
	);
};

exports.default = WMCircularProgress;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMCircularProgress/index.js